<template>
<router-view></router-view>
</template>

<script>

import { mapMutations, mapGetters, mapActions } from 'vuex';

import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMut from '../store/mutations/navigation';

export default {
    name: "EventData",
    data: function(){
        return {
            shd: {
                name: "SendHeatDetails",
                method: (data) => {
                    if(data.id === this.HeatGuid) {
                        if(data.entries.length === 0 && data.disabled) {
                            this.SETSELECTEDHEAT({id:null, heat: null});
                            alert(this.$i18n.t('text.poolMergeMessage.mergeDone'));
                            this.$router.push('/competition/events/' );
                        }
                        else{
                            this.SETSELECTEDHEAT({id:data.id, heat: data});
                        }
                    }
                }
            },
            shgru: {
                name: "ReceiveHeatGroupRankUpdate",
                method: (data) => {
                    this.updateEntrie(data.entryRankUpdates);
                }
            }, 
        }
    },
    methods:{
        ...mapMutations([glMut.SETSELECTEDHEAT,
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,
            glMut.RANKUPDATE,
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT
            ]),
        ...mapActions([glAct.GETHEATDETAILS]),        
        updateEntrie(rankUpdate){
            rankUpdate.forEach(x => this.RANKUPDATE(x));
        },
        registerMethods() {
            this.REGISTERHUB(this.shd);            
            this.REGISTERHUB(this.shgru);            
            this.GETHEATDETAILS();
        },
        unregisterMethods() {
            this.UNREGISTERHUB(this.shd);            
            this.UNREGISTERHUB(this.shgru);
        },
    },
    computed:{
        ...mapGetters(['ConnectionState', 'HeatGuid']),
    },
    watch: {
        ConnectionState(val){            
            if(val !== 0) {
                this.registerMethods();
            }
            else{
                this.unregisterMethods();
            }
        }
    },
    created(){
        if(this.ConnectionState !== 0){
            this.registerMethods();
        }
        else{
            const heat = JSON.parse(localStorage.getItem(this.HeatGuid));
            if(heat && heat.length != 0) {
                this.SETSELECTEDHEAT({id:this.HeatGuid, heat: heat.heat});
            }
        }
    },
    mounted(){        
        this.SHOWNAVPOINT([2]);
    },
    beforeDestroy(){
        this.unregisterMethods();
        this.HIDENAVPOINT([2]);
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .body {
        width: 100vw;
    }

</style>